import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Mixpanel } from "../../../components/shared/Mixpanel";
import * as UserActions from "../../../redux/actions/user";
import * as SearchActions from "../../../redux/actions/search";
import Page from "../../index";
import Container from "../container";
import { Main } from "./components";
import CloseIcon from "@material-ui/icons/Close";
import Logo from "../../../components/header/component/Logo";
import Wrapper from "./styles/index.style";

function LicensingInquiry(props) {
  const winWidth = window.innerWidth;
  const prevPath = localStorage.getItem("prevPath")
    ? localStorage.getItem("prevPath")
    : "";
  const prevUrl =
    prevPath !== "" ? localStorage.getItem("prevPath") : "/licensing";

  useEffect(() => {
    Mixpanel.track("View Inquiry Page");
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <Page
      id="inquiry"
      title="Inquiry Form"
      description="Browse and license from the world's most up-to-date and comprehensive footage library of user-generated and viral video clips."
      contentType="website"
    >
      <Container headerSticky={false} disableFooter={winWidth > 991}>
        <Wrapper>
          <Link
            onClick={() => {
              localStorage.removeItem("prevPath");
            }}
            to={prevUrl}
          >
            <CloseIcon className="close-icon" />
          </Link>
          <Logo />
          <Main {...props} />
        </Wrapper>
      </Container>
    </Page>
  );
}

export default connect(
  (state) => ({
    auth: state.auth,
    search: state.search,
    user: state.user,
  }),
  { ...UserActions, ...SearchActions }
)(LicensingInquiry);
